/**
 * Created by Bart Decorte
 * Date: 11/05/2020
 * Time: 19:34
 */

function stringStudly(value) {
  return value.replace('-', '_')
    .split('_')
    .map(piece => piece.charAt(0).toUpperCase() + piece.substr(1).toLowerCase())
    .join('')
  ;
}

export {
  stringStudly,
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/string_helper.js